import axios from '@/lib/axios'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

const headers = {
	'Content-Type': 'application/json',
	'Access-Control-Allow-Credentials': true,
}

window.Pusher = Pusher
Pusher.logToConsole = true

window.Echo = new Echo({
	broadcaster: 'reverb',
	key: import.meta.env.VITE_REVERB_APP_KEY,

	wsHost: import.meta.env.VITE_REVERB_HOST,
	wsPort: import.meta.env.VITE_REVERB_PORT,
	wssPort: import.meta.env.VITE_REVERB_PORT,
	forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
	enabledTransports: ['ws', 'wss'],
	authEndpoint: `${import.meta.env.VITE_PUBLIC_BACKEND_URL}/broadcasting/auth`,
	authorizer: (channel, options) => {
		return {
			authorize: (socketId, callback) => {
				axios
					.post('/broadcasting/auth', {
						socket_id: socketId,
						channel_name: channel.name,
					})
					.then((response) => {
						callback(null, response.data)
					})
					.catch((error) => {
						callback(error)
					})
			},
		}
	},
})
